import { getPage } from './getPage';
import { updateCart } from './updateCart';
import { getParam } from '../helpers/getParam';

const handleAddToCart = (sku, quantity = 1) => {
    const uid = getParam('uid');
    if (!sku) {
        console.warn('SKU not found');
        return;
    }
    let cart = JSON.parse(localStorage.getItem(`${uid}-cart`)) || [];
    const index = cart.findIndex((item) => item.id === sku);

    if (index === -1) {
        cart.push({ id: String(sku), quantity: quantity });
    }

    localStorage.setItem(`${uid}-cart`, JSON.stringify(cart));
    updateCart();
};


export const getProduct = (products, containerType) => {
  const getRandomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

  let productHTML = '';
  let numProducts;

  const filteredProducts = products.filter((product) => {
    const isSpecial = product.name && product.name.includes('special-promotion');

    if (containerType === 'special-product__content') {
      return isSpecial;
    } else {
      return !isSpecial;
    }
  });

  if (filteredProducts.length === 0) return;

  if (containerType === 'ha-product__content') {
    numProducts = 5;
    const randomProducts = [];
    while (randomProducts.length < numProducts) {
      const randomIndex = getRandomInt(0, filteredProducts.length - 1);
      const randomProduct = filteredProducts[randomIndex];
      if (!randomProducts.some((product) => product.sku === randomProduct.sku)) {
        randomProducts.push(randomProduct);
      }
    }
    productHTML = randomProducts
      .map(
        (product) => `
      <div class="ha-product__box get_product" data-order-type="${product.sku}">
        <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
        <div class="ha-product__info">
          <div class="ha-product__name">${product.templates.title}</div>
          <div class="ha-product__price">${
            window.options?.currency ? window.options.currency : '$'
          }${product.price.toFixed(2)}</div>
        </div>
      </div>
    `
      )
      .join('');
  } else if (containerType === 'home-product__content') {
    numProducts = filteredProducts.length;
    productHTML = filteredProducts
      .map(
        (product) => `
      <div class="home-product__box get_product" data-order-type="${product.sku}">
        <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
        <span>${product.templates.title}</span>
      </div>
    `
      )
      .join('');
  } else if (containerType === 'product-list') {
    numProducts = filteredProducts.length;
    productHTML = filteredProducts
      .map(
        (product) => `
       ${product.templates.title} <br>
       ${product.templates.title.toUpperCase()} BOTTLE - ${
          window.options?.currency ? window.options.currency : '$'
        }${product.price.toFixed(2)}<br> <br>
    `
      )
      .join('');
  } else if (containerType === 'ap-content') {
    numProducts = filteredProducts.length;
    productHTML = filteredProducts
      .map(
        (product) => `
      <div class="ap-item get_product" data-order-type="${product.sku}">
        <div  class="ap-item__img">
          <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
        </div>
        <div class="ap-item__name">${product.templates.title}</div>
        <div class="ap-item__price">${window.options?.currency ? window.options.currency : '$'}${product.price.toFixed(
          2
        )}</div>
      </div>
    `
      )
      .join('');
  } else if (containerType === 'banner-flex') {
    numProducts = 4;
    const randomProducts = [];
    while (randomProducts.length < numProducts) {
      const randomIndex = getRandomInt(0, filteredProducts.length - 1);
      const randomProduct = filteredProducts[randomIndex];
      if (!randomProducts.some((product) => product.sku === randomProduct.sku)) {
        randomProducts.push(randomProduct);
      }
    }
    productHTML = randomProducts
      .map(
        (product) => `
      <div class="banner-box">
        <div class="banner-box__img">
          <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
        </div>
        <div class="banner-box__body">
          <div class="banner-box__name">${product.templates.title}</div>
          <div class="banner-box__button get_product" data-order-type="${product.sku}">GO TO SHOP</div>
        </div>
      </div>
    `
      )
      .join('');
  } else if (containerType === 'cart-product-list') {
    productHTML = filteredProducts
      .map(
        (product) => `
      <div class="ap-item get_product" data-order-type="${product.sku}">
        <div  class="ap-item__img">
          <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
          <button class="home-product__btn">Add to cart</button>
        </div>
        <div class="ap-item__name">${product.templates.title}</div>
        <div class="ap-item__price">${window.options?.currency ? window.options.currency : '$'}${product.price.toFixed(
          2
        )}</div>
      </div>
    `
      )
      .join('');
  } else if (containerType === 'special-product__content') {
    const itemsHTML = filteredProducts
      .map((product, index) => {
        const currency = window.options?.currency ? window.options.currency : '$';
        const activeClass = index === 0 ? 'active' : '';
        const name = product.name || '';

        const hasShipping = name.includes('free-shipping');
        const hasBoost = /(^|-)boost(-|$)/.test(name);

        const retailPrice = parseFloat(product.templates.retail);
        const savePercent = retailPrice ? Math.round(100 - (product.price * 100) / retailPrice) : 50;
        const saveClassName = `save${savePercent}`;

        const servingsMatch = name.match(/servings(\d+)/);
        const servingsCount = servingsMatch ? servingsMatch[1] : '150';
        let mServingsClass = 'servings';
        if (hasShipping) mServingsClass += ' shipping';
        if (hasBoost) mServingsClass += ' boost';

        let mServingsText = `${servingsCount} servings`;
        if (hasShipping || hasBoost) mServingsText += ' +';

        const pricePerServing = (product.price / parseInt(servingsCount)).toFixed(2);

        return `
        <div class="itm ${activeClass}" 
             data-sku="${product.sku}" 
             data-img="/static/common/shared/products/${product.templates.imageLink}"
             data-has-shipping="${hasShipping}"> <div class="l-side">
            <div class="l">
               <div class="custom-radio"></div>
            </div>
            <div class="m">
              <div class="name">
                <h3>${product.templates.title}</h3>
                <div class="save ${saveClassName}">SAVE ${savePercent}%</div>
              </div>
              <div class="${mServingsClass}">${mServingsText}</div>
            </div>
          </div>
          <div class="r-side">
            <div class="r">
              <div class="block-price">
                <h4 class="retail">${product.templates.retail > 0 ? currency + product.templates.retail : ''}</h4>
                <h5 class="price">${currency}${product.price.toFixed(2)}</h5>
              </div>
              <div class="servings">${currency}${pricePerServing}/servings</div>
            </div>
          </div>
        </div>
      `;
      })
      .join('');

    const firstHasShipping = filteredProducts[0].name.includes('free-shipping');

    productHTML = `
        <div class="left-side">
          <div class="window">
            <img src="/static/common/shared/products/${
              filteredProducts[0].templates.imageLink
            }" width="416" class="bottle" id="dynamic-bottle" />
            <img src="/static/common/shared/ship-free.svg" 
                 class="ship-free" 
                 style="display: ${firstHasShipping ? 'block' : 'none'};">
          </div>
        </div>
        <div class="right-side">
          <div class="str5">
            <img src="/static/common/shared/5strs.svg">
            5,000+ verified 5-star reviews*
          </div>
          <div class="list">
            ${itemsHTML}
          </div>
          <div class="add_to_cart" data-sku="${filteredProducts[0].sku}">ADD TO CART</div>
        </div>
    `;

    $(document)
      .off('click', '.add_to_cart')
      .on('click', '.add_to_cart', function (e) {
        e.stopPropagation();
        const sku = $(this).attr('data-sku');

        if (!sku || $(this).hasClass('disabled')) {
          console.warn('SKU is missing on button');
          return;
        }

        $('.popup-product').show();
    
        setTimeout(() => {
          $('.popup-product__in .loader').hide();
          $('.after-load').addClass('show');
          $('.popup-product__in').addClass('loaded');

          handleAddToCart(sku);
        }, 1000);
      });

    $(document)
      .off('click', '.close_popup-product')
      .on('click', '.close_popup-product', function () {
        $('.popup-product').hide();
        $('.popup-product__in .loader').show();
        $('.after-load').removeClass('show');
        $('.popup-product__in').removeClass('loaded');

        if (typeof updateCart === 'function') {
            updateCart();
        }
      });
  }
  $(document).on('click', '.special-product__content .itm', function () {
    const $this = $(this);
    const sku = $this.data('sku');
    const imgSrc = $this.data('img');
    const hasShipping = $this.data('has-shipping');

    $('.itm').removeClass('active');
    $this.addClass('active');

    $('#dynamic-bottle').attr('src', imgSrc);
    $('.add_to_cart').attr('data-sku', sku);

    if (hasShipping) {
      $('.ship-free').show();
    } else {
      $('.ship-free').hide();
    }
  });

  $(`.${containerType}`).html(productHTML);

  $('.get_product').click(function (e) {
    const $target = $(e.currentTarget);
    const sku = $target.data('order-type');
    localStorage.setItem('product', sku);

    window.location.href = `${getPage('product')}&id=${sku}`;
  });
};
